/**
 * * @module view/common.js
 */
import regeneratorRuntime from "regenerator-runtime";
import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";
import Bootstrap from "bootstrap";
import BootstrapSelect from "bootstrap-select";
import VimeoPlayer from "@vimeo/player";
import owlCarousel from "owl.carousel";
import Cookies from "js-cookie";
import Gallery from "../components/gallery"
// import Reviews from "../components/reviews";
import People from "../components/people";
// import Downloads from "../components/downloads";
import Logos from "../components/logos";
import PromoBlocks from "../components/promo-blocks";
import RelatedArticles from "../components/related-articles";
import Navigation from "../components/navigation";
import Subnavigation from "../components/subnavigation";
import Donation from "../components/donation";
import Faq from "../components/faq";
import MobileAndTabletCarousel from "../components/mobile-and-tablet-carousel";
import Filter from "../components/filter";
import CogCredits from "../components/cog-credits";
import "../components/cog-booking";
import Tooltip from "../components/tooltip";


import Event from "../pages/event-single";
import Project from "../pages/project-single";
import Whatson from "../pages/whatson";
import GetInvolved from "../pages/get-involved";
import Memberships from "../pages/memberships";
import News from "../pages/news";
import Basket from "../pages/basket";
// import JobsList from "../pages/jobs-list";
import NewsSingle from "../pages/news-single";
import OurStory from "../pages/our-story";
import AccessPerformances from '../pages/access-performances';
import TicketDiscounts from '../pages/ticket-discounts';

const CommonView = Backbone.View.extend({
  el: $(document),

  events: {
    "click .radio-button-container .check": "controlInputSelection",
    "click #message-bar .announcement-banner-close": "dismissSiteMessage",
    "click #cookies-bar .announcement-banner-close": "dismissCookiesMessage",
    "submit #mailinglistsignup": "mailingListSignup",
    "click .wpcf7-list-item.has-free-text.radio-button-container .check": "enableFreeText",
    "click .fundraising .promo-link": "fundraisingForm"
  },

  initialize: function () {
    this.render();
  },

  fundraisingForm: function(e){
    e.preventDefault()
    
    let el = $(e.currentTarget)
    el.parent().hide()
    el.parent().next().show()
  },

  enableFreeText: function(e){
    const $check = $(e.target)
    $check.prev().prev().removeAttr("disabled").focus();
  },

  hideLabel: function () {
    $(".mailing-list-wrapper input[type='text']").each(function () {
      $(this).attr("placeholder", $(this).prev("label").text());
    });
  },

  controlInputSelection: function (e) {
    $(e.target).prev("input").prop("checked", true);
  },

  dismissSiteMessage: function () {
    Cookies.set("announcement", true, { expires: 1 });
    // console.log(Cookies);
    $("#message-bar").remove();

    return false;
  },

  dismissCookiesMessage: function () {
    Cookies.set("cookies", true, { expires: 1 });
    // console.log(Cookies);
    $("#cookies-bar").remove();

    return false;
  },

  cookies: function () {
    const $announcement = $("#message-bar");

    if ($announcement) {
      let consent = Cookies.get("announcement");
      if (!consent) {
        $announcement.show();
      } else {
        $announcement.remove();
      }
    }

    const $cookieBar = $("#cookies-bar");

    if ($cookieBar) {
      let consent = Cookies.get("cookies");
      if (!consent) {
        $cookieBar.show();
      } else {
        $cookieBar.remove();
      }
    }
  },

  scrollIframe: function(){
    $("html, body").animate(
      { scrollTop: $("#SpektrixIFrame").offset().top },
      2000
    );
  },

  amendCheckboxes: function(){

    $('.wpcf7 .wpcf7-checkbox input[type="checkbox"]').each(function () {
      let $checkbox = $(this);
      const $label = $checkbox
        .parent("label");
      if ($label.length > 0) {
        $checkbox
          .parent("label")
          .addClass("checkbox-label")
          .append('<span class="checkbox-span"></span>');
      }else{
        const id = 'check-' + Math.floor(Math.random() * Math.floor(100));
        $checkbox.attr("id", id);
        $checkbox.after(
          $(
            '<label for="' +
            id +
            '" class="checkbox-label"><span class="checkbox-span"></span></label>'
          )
        );
      }

      $checkbox.change(function () {
        if(this.checked){
          $(this).parent('label').addClass('checkedLabel');
        } else{
          $(this).parent('label').removeClass('checkedLabel');
        }
      });

      $('.wpcf7-list-item.last has-free-text.radio-button-container').each(function(){

      });
    });

  },

  amendRadioboxes: function(){

    $('.wpcf7 .wpcf7-radio .wpcf7-list-item').each(function () {
      let $wrapper = $(this);
      let $radio = $('input[type="radio"]', $wrapper);
      $wrapper.append($radio);
      $wrapper.addClass("radio-button-container");
      $wrapper.append('<div class="check"></div>');

      $(".radio-button-container .check").on("click", function (e) {
        $(e.target).prev("input").prop("checked", true);
      });
    })
  },

  /** Ajax signup */
  mailingListSignup: function (e) {

    // SEE captcha.js
    // 
    // console.log('SIGNUP')
    // var form = $(e.currentTarget)
    // var data = {
    //   ajax: true,
    //   form: form.serialize(),
    //   'mailing-list': true
    // }
    // $.post(location.href, data, function (response) {
    //   // console.log(response)
    //   var response = JSON.parse(response)
    //   $('.mailing-list-wrapper .container').html(response.response)
    //   if (response.redirect) {
    //     location.href = response.redirect
    //   }
    // })
    return false
  },

  render: function () {
    // window.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady();
    const _this = this;
    const gallery = new Gallery();
    gallery.galleryCarousel();

    // const reviews = new Reviews();
    // reviews.reviewsMobileOnlyCarousel();

    const people = new People();
    // const downloads = new Downloads();
    const supporters = new Logos();
    const promoBlocks = new PromoBlocks();
    const relatedArticles = new RelatedArticles();
    const navigation = new Navigation();
    const subnavigation = new Subnavigation();
    const donation = new Donation();
    const faq = new Faq();
    const cogCredits = new CogCredits();

    const tooltip = new Tooltip();

    if ($("body").hasClass("home")) {
      const mobileAndTabletCarousel = new MobileAndTabletCarousel();
    }

    if ($("body").hasClass("single-event")) {
      const event = new Event();
    }

    if ($("body").hasClass("page-template-whatson")) {
      const whatson = new Whatson();
    }

    if ($("body").hasClass("single-project")) {
      const project = new Project();
      const event = new Event();
    }

    if ($("body").hasClass("page-template-page-get-involved")) {
      const getInvolved = new GetInvolved();
    }

    if (
      $("body").hasClass("page-template-membership")) {
      const memberships = new Memberships();
    }

    if ($("body").hasClass("page-template-ticket-discounts")) {
      const ticketDiscounts = new TicketDiscounts();
    }

    if ($("body").hasClass("page-template-page-news-list")) {
      const news = new News();
    }

    if ($("body").hasClass("page-template-page-custom-basket")) {
      const basket = new Basket();
    }

    // if ($("body").hasClass("page-template-page-jobs")) {
    //   const jobsList = new JobsList();
    // }

    if ($("body").hasClass("single-post")) {
      const newsSingle = new NewsSingle();
    }

    if ($("body").hasClass("page-template-page-our-story")) {
      const ourStory = new OurStory();
    }
    
    if ($("body").hasClass("page-template-access-performances")){
      const accessPerformances = new AccessPerformances();
    }

    if ($("body").hasClass("search-results")) {
      const search = new Filter();
    }

    // this.hideLabel();

    this.cookies();

    window.addEventListener("message", (event) => {
      if (event.data.scrolltop) {
        _this.scrollIframe();
      }
    });

    this.amendCheckboxes();
    this.amendRadioboxes();

  },
});

export default CommonView;